import useI18n from '@/hooks/useI18n';
import { useModel } from '@umijs/max';
import { useRequest } from 'ahooks';
import { Empty, Image, Modal, Spin, Typography } from 'antd';
import { useEffect } from 'react';
import styles from '../index.less';
import { getOfferDetailService, getOfferImgService } from '../services';
const OfferDetail = ({ onClose }: { onClose: () => void }) => {
  const { formatMessage } = useI18n();
  const { currentOffer, setCurrentOffer } = useModel('MemberMgr.memberModel');

  const {
    loading: offerImageLoading,
    data: offerImags,
    run: queryOfferImg,
  } = useRequest(getOfferImgService, { manual: true });

  const {
    loading: offerDetailLoading,
    data: offerDetail,
    run: queryOfferDetail,
  } = useRequest(getOfferDetailService, { manual: true });

  // 查询offerImgs
  useEffect(() => {
    if (currentOffer?.id || currentOffer?.subsPlan?.offerId) {
      const offerId = currentOffer?.id || currentOffer?.subsPlan?.offerId;
      // 查询offerImgs
      queryOfferImg({
        offerId: offerId,
      });
      // 查询当前选中的offer详情
      queryOfferDetail(offerId, {});
    }

    return () => {
      setCurrentOffer({});
    };
  }, [currentOffer?.id, currentOffer?.subsPlan?.offerId]);

  return (
    <Modal
      title={formatMessage('memberMgr.offerDetail')}
      width={'50%'}
      centered={true}
      open={true}
      footer={null}
      onCancel={() => {
        onClose();
      }}
      destroyOnClose
    >
      <Spin spinning={offerImageLoading || offerDetailLoading}>
        {/** 判断图片长度，如果是一张，则直接展示原图大小，大于1张，保持原样 */}
        {offerImags?.length > 0 ? (
          offerImags?.length === 1 ? (
            <div className={styles.singleOfferImageContainer}>
              <img
              src={`data:image/png;base64,${offerImags[0]?.imageResource}`}
              alt="offerImage"
              className={styles.singleOfferImageWrap}
            />
            </div>
          ) : (
            <div className={styles.offerImageContainer}>
              <div>
                {offerImags?.map((offer: any) => (
                  <Image
                    key={offer?.resourceId}
                    style={{ width: 110, height: 60, marginBottom: 10 }}
                    src={`data:image/png;base64,${offer?.imageResource}`}
                    alt="base64 image"
                    preview={{
                      src: `data:image/png;base64,${offer?.imageResource}`,
                      style: { width: '100%', marginBottom: 10 },
                    }}
                  />
                ))}
              </div>
            </div>
          )
        ) : null}
        {offerImags?.length === 0 ? (
          <div style={{ marginTop: 30 }}>
            <Empty />
          </div>
        ) : null}
        <Typography>
          <Typography.Paragraph
            ellipsis={{ rows: 3 }}
            style={{ paddingTop: 20 }}
          >
            {offerDetail?.description}
          </Typography.Paragraph>
        </Typography>
      </Spin>
    </Modal>
  );
};
export default OfferDetail;
